export const LOGO_ICON = '/logo-icon.png';
export const LOGO_FULL = '/logo-full.png';
